/* eslint-disable no-param-reassign */
import React from 'react'
import ReactDOM from 'react-dom'
import ajaxRequest from './request'

const GOODS_SOURCE = {
  100: '小店',
  101: '淘宝',
  102: '天街',
  103: '有赞',
  104: '快手'
}

const GOODS_TYPE_ICONS = {
  100: 'icondouyin',
  101: 'icontaobao',
}

export const formatNum = (num, toFixedNum = 0) => {
  if (typeof num !== 'number' && typeof num !== 'string') return num?.toLocaleString?.()
  if (Math.abs(num) >= 100000000) {
    return `${Number(((num) / 100000000).toFixed(toFixedNum)).toLocaleString()}e`
  }
  if (Math.abs(num) >= 10000) {
    return `${Number(((num) / 10000).toFixed(toFixedNum)).toLocaleString()}w`
  }
  if (Math.abs(num) >= 1000) {
    return `${Number(((num) / 1000).toFixed(toFixedNum)).toLocaleString()}k`
  }
  return Number((num).toFixed(toFixedNum)).toLocaleString()
}

const obj = {
  /**
   * 是否白色
   * @param {String} colorStr
   */
  isWhite(colorStr) {
    if (!colorStr) return false
    if (/#([\d\w]{3,6})/.test(colorStr)) {
      const str = colorStr.replace('#', '').toUpperCase()
      return str === 'FFF' || str === 'FFFFFF'
    }
    const rgbMatch = colorStr.match(/rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/)
    if (rgbMatch.length > 0) {
      return rgbMatch[1] === '255' && rgbMatch[2] === '255' && rgbMatch[3] === '255'
    }
    return false
  },
  isDark(bgColor) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(bgColor)
    const darkness = 1 - (0.299 * parseInt(result[1], 16) + 0.587 * parseInt(result[2], 16) + 0.114 * parseInt(result[3], 16)) / 255
    // darkness < 0.5 为浅色模式
    return darkness > 0.3
  },
  // 格式化淘宝模糊数据
  formatTaobaoVagueData(val, short = true, unit = '') {
    if (val === null || val === undefined || Number.isNaN(val)) {
      return '-'
    }
    if (val >= 5000 && val < 10000 && (val % 500) === 0) {
      return `${val}+`
    } if (val >= 10000 && val % 1000 === 0) {
      return `${short ? this.dealBigNum(val) : val}${unit}+`
    }
    return (short ? this.dealBigNum(val) : val) + unit
  },
  /**
   * 格式化淘宝销售额方法
   * @param {*} val 数值
   * @param {*} short 是否超过10W元自动转换为万元
   * @param {*} unit 单位
   */
  formatTaobaoVagueSale(val, short = true, unit = '') {
    return this.formatTaobaoVagueData(val / 100, short, unit)
  },
  /**
   * 处理粉丝
   * @deprecated 由于命名问题，请使用formatNumber
   * @param {number}} value
   * @param {*} wan
   */
  // 处理粉丝
  formatFans(value, wan = '万') {
    if (value === null || value === undefined || typeof value !== 'number') return 0
    return Math.abs(value) < 10000 ? value : <span>{(value / 10000).toFixed(1)}{wan}</span>
  },
  // 处理粉丝 纯字符串
  formatNoTagFans(value, wan = '万') {
    if (value === null || value === undefined || typeof value !== 'number') return 0
    return Math.abs(value) < 10000 ? value : (value / 10000).toFixed(1) + wan
  },
  /**
   * 大数字转换方法
   * @param {*} num 要转换的数字
   * @param {JSX.Element} unit 单位名（可以为react dom）
   * @param {*} value 单位进制
   */
  formatNumber(num, unit = '万', unitValue = 10000, noneText = 0) {
    if (num === null || num === undefined || typeof num !== 'number') return noneText
    return Math.abs(num) < unitValue ? num : <span style={{ whiteSpace: 'nowrap' }}>{(num / unitValue).toFixed(1)}{unit}</span>
  },
  /**
   * 格式化抖音图片URL
   * @param {string} url
   * @return {string}
   */
  formatDYUrl(url) {
    // https://sf6-ttcdn-tos.pstatp.com/img/temai/a77f55c7ac3af843576c22d1fac9a8d490481109www1280-1280~tplv-resize:200:0.webp
    if (/sf6-ttcdn-tos\.pstatp\.com|sf1-ttcdn-tos\.pstatp\.com/.test(url)) {
      return url.replace(':200:0', ':800:0').replace('.webp', '.jpeg')
    } if (/\.byteimg\.com/.test(url)) {
      return url.replace('.webp', '.jpeg')
    }
    return url
  },
  /**
   * 处理亿级别的数字
   * @param {*} num 要转换的数字
   */
  dealBillionNumber(num) {
    if (num > 10000 * 10000) {
      return this.formatNumber(num)
    }
    return this.formatNumber(num, '亿', 10000 * 10000)
  },
  autoFormatNumber(num, noneText, unitStyle,) {
    if (num > 100000000) this.formatNumber(num, <span className="number-unit" style={unitStyle}>亿</span>, 100000000)
    return this.formatNumber(num, <span className="number-unit" style={unitStyle}>万</span>)
  },
  // 处理商品对象的大数值
  dealBigNum(value, accuracy = 100000, fixed = 1) {
    if (value === null || value === undefined || typeof value !== 'number') return '-'
    return value < accuracy ? value : `${(value / 10000).toFixed(fixed)}万`
  },
  // 处理百分数
  dealRadio(num, isShowPer = false, accuracy = 2) {
    const result = num ? (num * 100).toFixed(accuracy) : 0.00
    return isShowPer ? `${result}%` : result
  },
  // 处理日期
  dealDate(date, showDetail = true) {
    if (!date) return
    return showDetail ? date.split('.')[0] : date.split(' ')[0]
  },
  // 事件统计管理
  eventCount: {
    // 添加
    add(eventId, options = {}) {
      options.time = new Date().getTime()
      const imgData = {
        eventId,
        eventDescription: JSON.stringify(options)
      }
      // 发送图片请求
      this.sendImg(imgData)
    },

    sendImg(params) {
      const a = new Image()

      let args = ''
      for (const i in params) {
        if (args !== '') {
          args += '&'
        }
        args += `${i}=${encodeURIComponent(params[i])}`
      }
      a.src = `${ajaxRequest.baseUrl}/users/v1/event-observe?${args}`
    }
  },
  // 数组转字符串
  dealListData(arr) {
    let str = ''
    for (let i = 0; i < arr.length; i++) {
      if (i < (arr.length - 1)) {
        str += `${arr[i]},`
        // eslint-disable-next-line no-continue
        continue
      }
      str += arr[i]
    }
    return str
  },

  // obj->string
  // eslint-disable-next-line no-shadow
  objToSearch(obj) {
    const search = []
    for (const key in obj) {
      if (obj[key] !== undefined) {
        search.push(`${key}=${encodeURIComponent(obj[key])}`)
      }
    }
    return search.join('&')
  },
  destory(resolve, div, val) {
    const unmountResult = ReactDOM.unmountComponentAtNode(div)
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div)
      resolve(val)
    }
  },
  // 转化商品来源平台
  getItemPlatform(source) {
    return GOODS_SOURCE[source] || '-'
  },
  // 转化商品来源平台icon
  getItemPlatformIcon(source) {
    return GOODS_TYPE_ICONS[source] || '-'
  },
  /**
   * @description 抖衣项目的数字格式化工具，返回格式化DOM
   * @param {number} num 数字值
   * @param {string || number} [noneText='-'] 数字为空时返回的状态
   * @param {CSSProperties} [unitStyle] 单位的样式
   * @returns ReactNode
   */
  // eslint-disable-next-line default-param-last
  dyAutoFormatNumber(num, noneText = '-', className, unitStyle) {
    const YI = 10000 * 10000 // 亿
    const WAN = 10000 // 万
    if (num === null || num === undefined) {
      return <span className={className}>{noneText}</span>
    }
    if (isFinite(num)) {
      if (Math.abs(num) > 10 * YI) {
        return <span style={{ whiteSpace: 'nowrap' }} className={className}>
          {(num / YI).toFixed(1)}
          <span className="number-unit" style={unitStyle}>亿</span>
        </span>
      }
      if (Math.abs(num) > 10 * WAN) {
        return <span style={{ whiteSpace: 'nowrap' }} className={className}>
          {(num / WAN).toFixed(1)}
          <span className="number-unit" style={unitStyle}>万</span>
        </span>
      }
      return <span style={{ whiteSpace: 'nowrap' }} className={className}>{num}</span>
    }
    return noneText
  },
}

export default obj
